import { useExperience } from "@shared-core/domain/experience";
import { DashboardLayout } from "./DashboardLayout";
import { OneLayout } from "./domain/one/OneLayout";

/**
 * The root layout: One's object sidebar when One is chosen in the account
 * menu (and the `one` feature is on), otherwise Classic's top menu,
 * `DashboardLayout`, exactly as it was.
 */
export function AppLayout() {
  const { experience } = useExperience();
  return experience === "one" ? <OneLayout /> : <DashboardLayout />;
}
